import { useState, useEffect } from "react"

function WillPage(){

const [nomineeName,setNomineeName] = useState("")
const [nomineeEmail,setNomineeEmail] = useState("")
const [nomineePhone,setNomineePhone] = useState("")
const [nomineePassword,setNomineePassword] = useState("")
const [text,setText] = useState("")
const [wills,setWills] = useState([])

useEffect(()=>{

fetch("https://final-trace.onrender.com/api/will/all")
.then(res=>res.json())
.then(data=>{
setWills(data)
})

},[])

const handleSave = async(e)=>{
e.preventDefault()

const res = await fetch("https://final-trace.onrender.com/api/will/save",{
method:"POST",
headers:{
"Content-Type":"application/json"
},
body:JSON.stringify({
nomineeName,
nomineeEmail,
nomineePhone,
nomineePassword,
text
})
})

const data = await res.json()

alert(data.message + "\n\nNominee has been notified.")

window.location.reload()

}

const deleteWill = async(id)=>{

await fetch(`https://final-trace.onrender.com/api/will/delete/${id}`,{
method:"DELETE"
})

alert("Will deleted successfully")

window.location.reload()

}

return(

<div style={{
display:"flex",
justifyContent:"center",
alignItems:"flex-start",
minHeight:"100vh",
background:"linear-gradient(135deg,#1e3c72,#2a5298)",
paddingTop:"40px"
}}>

<div style={{
background:"white",
padding:"40px",
borderRadius:"12px",
width:"500px",
boxShadow:"0 8px 20px rgba(0,0,0,0.2)"
}}>

<h2 style={{textAlign:"center"}}>Digital Will</h2>

<form onSubmit={handleSave}>

<h3>Nominee Details</h3>

<input
placeholder="Nominee Name"
value={nomineeName}
onChange={(e)=>setNomineeName(e.target.value)}
style={{
width:"100%",
padding:"10px",
marginBottom:"10px",
borderRadius:"6px",
border:"1px solid #ccc"
}}
/>

<input
placeholder="Nominee Email"
value={nomineeEmail}
onChange={(e)=>setNomineeEmail(e.target.value)}
style={{
width:"100%",
padding:"10px",
marginBottom:"10px",
borderRadius:"6px",
border:"1px solid #ccc"
}}
/>

<input
placeholder="Nominee Phone"
value={nomineePhone}
onChange={(e)=>setNomineePhone(e.target.value)}
style={{
width:"100%",
padding:"10px",
marginBottom:"10px",
borderRadius:"6px",
border:"1px solid #ccc"
}}
/>

<input
type="password"
placeholder="Nominee Password"
value={nomineePassword}
onChange={(e)=>setNomineePassword(e.target.value)}
style={{
width:"100%",
padding:"10px",
marginBottom:"10px",
borderRadius:"6px",
border:"1px solid #ccc"
}}
/>

<h3>Digital Will Instructions</h3>

<textarea
rows="5"
value={text}
onChange={(e)=>setText(e.target.value)}
placeholder="Example: Transfer my bank account to my family"
style={{
width:"100%",
padding:"10px",
borderRadius:"6px",
border:"1px solid #ccc"
}}
/>

<button
type="submit"
style={{
width:"100%",
padding:"12px",
marginTop:"20px",
background:"#2a5298",
color:"white",
border:"none",
borderRadius:"6px",
cursor:"pointer"
}}
>
Save Will
</button>

</form>

<h3 style={{marginTop:"30px"}}>Saved Wills</h3>

{wills.map((will)=>(

<div key={will._id} style={{
border:"1px solid #e5e7eb",
padding:"12px",
marginTop:"12px",
borderRadius:"8px",
background:"#f8fafc",
boxShadow:"0 2px 8px rgba(0,0,0,0.1)"
}}>

<b>Nominee:</b> {will.nomineeName} <br/>
<b>Email:</b> {will.nomineeEmail} <br/>
<b>Phone:</b> {will.nomineePhone} <br/>
<b>Instructions:</b> {will.text}

<br/><br/>

<button
onClick={()=>deleteWill(will._id)}
style={{
background:"#dc2626",
color:"white",
border:"none",
padding:"6px 12px",
borderRadius:"5px",
cursor:"pointer"
}}
>
Delete
</button>

</div>

))}

</div>

</div>

)

}

export default WillPage